import { atom, useAtomValue, useSetAtom } from 'jotai';

const refetchGroupsStatusAtom = atom(1);

export const useRefetchGroups = () => {
  const refetchGroups = useAtomValue(refetchGroupsStatusAtom);
  const updateRefetchGroups = useSetAtom(refetchGroupsStatusAtom);

  return {
    refetchGroups,
    updateRefetchGroups,
  };
};
